import { render, staticRenderFns } from "./BubbleRingLoader.vue?vue&type=template&id=2d6f6002&scoped=true&"
import script from "./BubbleRingLoader.vue?vue&type=script&lang=js&"
export * from "./BubbleRingLoader.vue?vue&type=script&lang=js&"
import style0 from "./BubbleRingLoader.vue?vue&type=style&index=0&id=2d6f6002&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f6002",
  null
  
)

export default component.exports